import React from 'react';
import GoogleRatingBadge from '../reviews/GoogleRatingBadge';
import GoogleReviewsSection from '../index/GoogleReviewsSection';

function CallToAction({ showReviews = true }) {
    return (
        <>
            {showReviews && <GoogleReviewsSection />}
            <div className="call-to-action-wrapper call-to-action text-white-wrapper ptb--120">
                <div className="container pt-4 pt-md-0 pb-4 pb-md-0">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="inner text-center">
                                <GoogleRatingBadge
                                    locale="sl"
                                    className="google-rating-badge--cta"
                                />
                                <h2>Načrtujete svoj obisk?</h2>
                                <p className="cta-description mt--30 mb-0 font-weight-normal text-white">V občini Litija se nahaja več turističnih znamenitosti.<br className="d-none d-md-block" /> Vabljeni, da poleg rudnika obiščete še katero.</p>
                                <a className="btn-default btn-border btn-large btn-white mt--40" href="https://www.razvoj.si/virtualnapanorama/" target="_blank" rel="noopener noreferrer">Virtualni sprehod skozi Litijo</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CallToAction;
